import React from 'react';
import { defaultSettings } from './default/settings';
import { lazyLoad } from '@react-page/editor';
const Icon = lazyLoad(() => import('@mui/icons-material/CropLandscape'));
const createPlugin = (settings) => {
    var _a;
    const mergedSettings = Object.assign(Object.assign({}, defaultSettings), settings);
    const Controls = mergedSettings.Controls;
    const Renderer = mergedSettings.Renderer;
    const plugin = {
        controls: {
            type: 'custom',
            Component: (props) => React.createElement(Controls, Object.assign({}, props, mergedSettings)),
        },
        Renderer: (props) => React.createElement(Renderer, Object.assign({}, props, mergedSettings)),
        id: 'migeran/editor/core/layout/reusable/' + mergedSettings.id,
        version: 1,
        title: mergedSettings.name,
        description: mergedSettings.description ? mergedSettings.description : (_a = mergedSettings.translations) === null || _a === void 0 ? void 0 : _a.pluginDescription,
        icon: React.createElement(Icon, null),
        createInitialChildren: () => {
            return mergedSettings.value.rows;
        },
        cellStyle: mergedSettings.cellStyle,
    };
    return plugin;
};
export default createPlugin;
//# sourceMappingURL=createPlugin.js.map